import type { ServicePageListContent } from '../../data'

interface ServiceListProps {
  list: ServicePageListContent
}

export function ServiceList({ list }: ServiceListProps) {
  return (
    <>
      {list.intro ? <p>{list.intro}</p> : null}
      <ul className={list.columns === 2 ? 'service-list service-list--two-column' : 'service-list'}>
        {list.items.map((item) => <li key={item}>{item}</li>)}
      </ul>
    </>
  )
}
